/* ==========================================================
   LQK games kit — shared behaviours for all native games.
   No dependencies, no data collection. window.LQKG namespace.
   ========================================================== */
(function () {
  'use strict';
  if (window.LQKG) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- utils ---------- */

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function vibrate(ms) {
    try { if (navigator.vibrate) navigator.vibrate(ms); } catch (e) {}
  }

  /* ---------- tiny synth (no audio files) ---------- */

  var MUTE_KEY = 'lqkg-muted';
  var audioCtx = null;

  function ctx() {
    if (!audioCtx) {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      audioCtx = new AC();
    }
    if (audioCtx.state === 'suspended') audioCtx.resume();
    return audioCtx;
  }

  function muted() {
    try { return localStorage.getItem(MUTE_KEY) === '1'; } catch (e) { return false; }
  }

  function setMuted(v) {
    try { localStorage.setItem(MUTE_KEY, v ? '1' : '0'); } catch (e) {}
  }

  function tone(freq, dur, type, gainPeak, when) {
    var c = ctx();
    if (!c || muted()) return;
    var t0 = c.currentTime + (when || 0);
    var osc = c.createOscillator();
    var g = c.createGain();
    osc.type = type || 'sine';
    osc.frequency.setValueAtTime(freq, t0);
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(gainPeak || 0.18, t0 + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    osc.connect(g).connect(c.destination);
    osc.start(t0);
    osc.stop(t0 + dur + 0.05);
  }

  var sound = {
    muted: muted,
    toggle: function () { setMuted(!muted()); return muted(); },
    tap:  function () { tone(660, 0.08, 'sine', 0.12); },
    flip: function () { tone(520, 0.09, 'triangle', 0.1); },
    pop:  function () { tone(880, 0.07, 'square', 0.08); tone(1320, 0.05, 'sine', 0.06, 0.02); },
    ding: function () { tone(880, 0.18, 'sine', 0.16); tone(1318.5, 0.22, 'sine', 0.1, 0.06); },
    buzz: function () { tone(180, 0.16, 'sawtooth', 0.06); },
    win:  function () {
      [523.25, 659.25, 783.99, 1046.5].forEach(function (f, i) {
        tone(f, 0.22, 'triangle', 0.14, i * 0.11);
      });
    }
  };

  /* ---------- confetti ---------- */

  var COLORS = ['#e0a93b', '#333a22', '#dfc591', '#cfe0e3', '#f0d9d2', '#d6e4d0'];

  function confetti(opts) {
    if (reduced) return;
    opts = opts || {};
    var canvas = document.createElement('canvas');
    canvas.className = 'lqkg__confetti';
    document.body.appendChild(canvas);
    var g = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = innerWidth * dpr;
    canvas.height = innerHeight * dpr;
    g.scale(dpr, dpr);

    var n = opts.count || 130;
    var parts = [];
    for (var i = 0; i < n; i++) {
      parts.push({
        x: innerWidth * (0.2 + Math.random() * 0.6),
        y: -20 - Math.random() * innerHeight * 0.25,
        w: 6 + Math.random() * 6,
        h: 8 + Math.random() * 8,
        vx: (Math.random() - 0.5) * 2.4,
        vy: 2 + Math.random() * 2.6,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.24,
        color: COLORS[i % COLORS.length]
      });
    }
    var t0 = performance.now();
    (function frame(t) {
      var elapsed = t - t0;
      g.clearRect(0, 0, innerWidth, innerHeight);
      var alive = false;
      parts.forEach(function (p) {
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        if (p.y < innerHeight + 30) alive = true;
        g.save();
        g.translate(p.x, p.y);
        g.rotate(p.rot);
        g.fillStyle = p.color;
        g.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        g.restore();
      });
      if (alive && elapsed < 3800) requestAnimationFrame(frame);
      else canvas.remove();
    })(t0);
  }

  /* ---------- win modal ---------- */

  var STAR_SVG = '<svg class="lqkg__star" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.4L12 17.4l-5.8 3-1.1-6.4L.4 9.4l6.5-.9z"/></svg>';

  function modal(root) {
    /* mount inside the .lqkg scope so the kit's CSS variables resolve */
    root = root || document.querySelector('.lqkg') || document.body;
    var overlay = document.createElement('div');
    overlay.className = 'lqkg__overlay';
    overlay.setAttribute('data-open', 'false');
    overlay.innerHTML =
      '<div class="lqkg__modal" role="dialog" aria-modal="true" aria-labelledby="lqkg-modal-title">' +
        '<div class="lqkg__stars" aria-hidden="true">' + STAR_SVG + STAR_SVG + STAR_SVG + '</div>' +
        '<h3 id="lqkg-modal-title"></h3>' +
        '<p></p>' +
        '<div class="lqkg__modal-actions">' +
          '<button type="button" class="lqkg__btn" data-act="again"></button>' +
          '<a class="lqkg__btn lqkg__btn--ghost" data-act="all" href="/pages/lqk-games">All games</a>' +
        '</div>' +
      '</div>';
    root.appendChild(overlay);

    var titleEl = overlay.querySelector('h3');
    var textEl = overlay.querySelector('p');
    var againBtn = overlay.querySelector('[data-act="again"]');
    var stars = overlay.querySelectorAll('.lqkg__star');
    var onAgain = null;

    againBtn.addEventListener('click', function () {
      hide();
      if (onAgain) onAgain();
    });

    function show(cfg) {
      titleEl.textContent = cfg.title || 'Mumtaz! ⭐';
      textEl.textContent = cfg.text || '';
      againBtn.textContent = cfg.againLabel || 'Play again';
      onAgain = cfg.onAgain || null;
      var lit = typeof cfg.stars === 'number' ? cfg.stars : 3;
      stars.forEach(function (s, i) { s.classList.toggle('is-lit', i < lit); });
      overlay.setAttribute('data-open', 'true');
    }
    function hide() { overlay.setAttribute('data-open', 'false'); }

    return { show: show, hide: hide };
  }

  /* ---------- sound toggle button wiring ---------- */

  var SPEAKER_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
  var SPEAKER_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4z"/><line x1="22" y1="9" x2="16" y2="15"/><line x1="16" y1="9" x2="22" y2="15"/></svg>';

  function soundButton(btn) {
    function render() {
      var m = sound.muted();
      btn.innerHTML = m ? SPEAKER_OFF : SPEAKER_ON;
      btn.setAttribute('aria-pressed', m ? 'true' : 'false');
      btn.setAttribute('aria-label', m ? 'Turn sound on' : 'Turn sound off');
    }
    btn.addEventListener('click', function () { sound.toggle(); render(); if (!sound.muted()) sound.tap(); });
    render();
  }

  /* ---------- timer ---------- */

  function timer(el) {
    var start = null, raf = null, running = false, frozen = 0;
    function fmt(ms) {
      var s = Math.floor(ms / 1000);
      return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
    }
    function tick() {
      if (!running) return;
      el.textContent = fmt(performance.now() - start);
      raf = setTimeout(tick, 500);
    }
    return {
      start: function () { start = performance.now(); running = true; tick(); },
      stop: function () { running = false; clearTimeout(raf); frozen = start ? performance.now() - start : 0; return frozen; },
      reset: function () { running = false; clearTimeout(raf); el.textContent = '0:00'; },
      seconds: function () { return Math.round(((running ? performance.now() - start : frozen)) / 1000); }
    };
  }

  window.LQKG = {
    shuffle: shuffle,
    vibrate: vibrate,
    sound: sound,
    confetti: confetti,
    modal: modal,
    soundButton: soundButton,
    timer: timer,
    reducedMotion: reduced
  };
})();
